export default __webpack_public_path__ + "547fe84a02a579521160de151d3762e6.png";